export function findParent(element: Element, nodeName: string): Element | null {
  if (element.parentElement === null) return null;
  if (isEqualInLowerCase(element.parentElement.nodeName, nodeName)) return element.parentElement;
  return findParent(element.parentElement, nodeName);
}

function isEqualInLowerCase(value1: string, value2: string): boolean {
  return value2.toLowerCase() === value1.toLowerCase();
}
